/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {backfillCustomerBlocks} from '../api'

export const useMutationBackfillCustomerBlocks = createReactQueryMutationHook('backfillCustomerBlocks', backfillCustomerBlocks)
